var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"layout-container",attrs:{"id":_vm.info.id}},[(_vm.isEditMode)?[_c('img',{staticClass:"picture editMode",style:(_vm.info.style),attrs:{"src":_vm.info.src +
        '&imageMogr2/thumbnail/2000x3000/format/' +
        _vm.$pic_type +
        '/interlace/1'}})]:[_c('img',{staticClass:"picture forbid",style:(_vm.info.style),attrs:{"src":_vm.info.src +
        '&imageMogr2/thumbnail/2000x3000/format/' +
        "" + (_vm.info.src.toLowerCase().indexOf('gif') < 0 ? _vm.$pic_type : 'gif') +
        '/interlace/1'},on:{"click":function($event){return _vm.link()}}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }